CustomEvent = require './custom-event'

module.exports = (target, eventName, options = {}) ->
  event = new CustomEvent eventName,
    bubbles: options.bubbles ? true
    cancelable: options.cancelable ? false
    detail: options.detail ? undefined

  target.dispatchEvent(event)
